import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import ContentHeader from '../common/template/contentHeader';
import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import BoxButtonHeader from '../common/button/boxButtonHeader';
import Button from '../common/button/button';
import Form from './equipamentoForm';

import { setModoTela, initForm, salvar, excluir, getLista, getListaEspecie } from './equipamentoActions';

class Equipamento extends Component {

    componentWillMount() {
        this.props.getLista(this.props.sessao.id_empresa);
		this.props.getListaEspecie(this.props.sessao.id_empresa);
    }

    render() {
        return (
            <div>
                <ContentHeader title='Equipamento' small='Cadastro' />
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<BoxButtonHeader>
					<Button
						text='Adicionar'
						type={'success'}
						icon={'fa fa-plus'}
						style={{ position: 'fixed' }}
						event={() => {
							this.props.setModoTela('cadastro', {});
							this.props.initForm();
						}} />
				</BoxButtonHeader>
				<Table>
					<THead>
						<Tr>
							<Th>Nome/Descrição</Th>
							<Th>Placa</Th>
							<Th>Espécie</Th>
							<Th>Tipo de Média</Th>
							<Th>Reboque</Th>
							<Th>Esteira</Th>
							<Th alignCenter acoes>Ações</Th>
						</Tr>
					</THead>
					<TBody>
						{(this.props.lista).map(item => (
							<Tr key={item.id}>
								<Td>{item.nome}</Td>
								<Td>{item.placa}</Td>
								<Td>{item.nome_especie}</Td>
								<Td>{item.hodometro && item.horimetro ? 'Odômetro/Horímetro' : (item.hodometro ? 'Odômetro' : (item.horimetro ? 'Horímetro' : 'Nenhum'))}</Td>
								<Td>{item.reboque ? 'Sim' : 'Não'}</Td>
								<Td>{item.esteira ? 'Sim' : 'Não'}</Td>
								<Td alignCenter>
									<ButtonTable
										type={'warning'}
										icon={'fa fa-pencil'}
										event={() => {
											this.props.setModoTela('cadastro', item);
											this.props.initForm({
												...item,
												capacidade_tanque: item.capacidade_tanque ? item.capacidade_tanque.replace('.', ',') : 0
											});
										}} />
									<ButtonTable
										type={'danger'}
										icon={'fa fa-trash-o'}
										event={() => {
											this.props.setModoTela('exclusao', item);
											this.props.initForm({
												...item,
												capacidade_tanque: item.capacidade_tanque ? item.capacidade_tanque.replace('.', ',') : 0
											});
										}} />
								</Td>
							</Tr>
						))}
					</TBody>
				</Table>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.equipamento.modoTela,
	lista: state.equipamento.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, getLista, getListaEspecie }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Equipamento);
